
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningRainShowersNight as ObiLightningRainShowersNightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-rain-showers-night.js';
 
 
 

 
 export const ObiLightningRainShowersNight = createComponent({
   react: React,
   tagName: 'obi-lightning-rain-showers-night',
   elementClass: ObiLightningRainShowersNightElement,
   events: {
     
   }
  });
 
 